import { render } from "./ArchiveTable.vue?vue&type=template&id=f49e8fec"
import script from "./ArchiveTable.vue?vue&type=script&lang=js"
export * from "./ArchiveTable.vue?vue&type=script&lang=js"

import "./ArchiveTable.vue?vue&type=style&index=0&id=f49e8fec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__